// extracted by mini-css-extract-plugin
module.exports =  {"exercise":"Template35-VQXK__exercise","answer":"Template35-KhFb__answer","answer-title":"Template35-Ikc7__answer-title","answer-text":"Template35-Q5fi__answer-text"};